<!--处方选择-->
<template>
  <div class="prescriptionSelect" :class="{ show: show }">
    <div class="head">
      <Icon @click="close" type="md-arrow-forward" />
      <span>处方</span>
    </div>
    <div class="p_item" v-for="(item, index) in list" :key="index" :class="{ active: item.active }"
      @click="onItem(item, true)">
      <div class="title">
        {{ item.remark }}
        <Icon type="md-checkmark-circle" />
      </div>
    </div>
    <div class="p_item ai_item" v-if="!isAiReturnPrescription && is999 && hasAuth('YZ-35')">
      <div class="title">
        <span>智能体开方</span>
        <Icon type="ios-loading" size="18" class="demo-spin-icon-load"></Icon>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import StoreData from '../utils/StoreData';
export default {
  props: {
    list: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  watch: {
    list(newValue, oldValue) {
      this.init();
    },
  },
  data() {
    return {
      show: false,
      arr: [],
    };
  },
  computed: {
    ...mapGetters([
      "hideAi",
      "is999",
      "isAiReturnPrescription",
      "registerCode",
    ]),
  },
  methods: {
    onItem(item, changeData) {
      this.list.forEach((i) => (i.active = false));
      item.active = true;
      if (changeData) {
        this.$emit("change", this.common.clone(item));
      }
      new StoreData("prescriptionSelectActive", this.registerCode).add({
        remark: item.remark,
        planInfo: {
          planExplain: item.planInfo.planExplain,
          planName: item.planInfo.planName,
        }
      });
    },
    onShow() {
      this.show = true;
    },
    init() {
      if (this.list.length > 1 && !this.hideAi) {
        this.show = true;
      } else {
        this.show = false;
      }
    },
    close() {
      this.show = false;
    },
    removeActive() {
      this.list.forEach((i) => (i.active = false));
    },
    setActive(drugCodes) {
      let sitem = new StoreData("prescriptionSelectActive", this.registerCode).get();
      let item = sitem
        ? this.list.find((i) => i.remark == sitem.remark)
        : this.list.find((i) => {
          return (
            i.drugsList.length == drugCodes.length &&
            i.drugsList.every((j) => drugCodes.includes(j.drugCode))
          );
        });
      if (item) {
        this.onItem(item, false);
      } else {
        this.removeActive();
      }
    },
  },
  created() {
    this.init();
  },
  mounted() {
    this.$bus.on("quotingPrescriptions", this.removeActive);
    this.$bus.on("setPrescriptionSelectActive", this.setActive);
  },
  beforeDestroy() {
    this.$bus.off("quotingPrescriptions", this.removeActive);
    this.$bus.off("setPrescriptionSelectActive", this.setActive);
  },
};
</script>

<style lang="scss">
.prescriptionSelect .p_item.ai_item .title {
  cursor: not-allowed;

  span {
    opacity: 0.6;
  }

  i {
    visibility: visible;
    line-height: 22px;
  }
}
</style>